import {combineReducers} from "redux";
import {user} from './user';
import {app} from './app';
import {breadcrumbs} from './breadcrumbs';

export default  combineReducers({
    app,
    user,
    breadcrumbs
});